import { useEffect, useRef, useState } from "react";
import i18n from "../utils/i18n";

export const useLangBtn = () => {
  const languages = [
    { code: "en", label: "English", nativeLabel: "English" },
    { code: "ar", label: "Arabic", nativeLabel: "العربية" },
  ] as const;

  const [currentLang, setCurrentLang] = useState<"en" | "ar">(i18n.language as "en" | "ar");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleLanguageSelect = async () => {
    const newLang = currentLang === "en" ? "ar" : "en";
    const newDir = newLang === "ar" ? "rtl" : "ltr";

    try {
      await i18n.changeLanguage(newLang);
      localStorage.setItem("i18nextLng", newLang);
      localStorage.setItem("dir", newDir);
      document.documentElement.dir = newDir;
      setCurrentLang(newLang);
      window.location.reload();
    } catch (error) {
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const dir = localStorage.getItem("dir") || "rtl";
    document.documentElement.dir = dir;
  }, []);

  return {
    currentLang,
    isOpen,
    languages,
    handleLanguageSelect,
    setIsOpen,
    dropdownRef
  };
};